import { render, staticRenderFns } from "./menus.vue?vue&type=template&id=7fab045d&scoped=true"
import script from "./menus.vue?vue&type=script&lang=js"
export * from "./menus.vue?vue&type=script&lang=js"
import style0 from "./menus.vue?vue&type=style&index=0&id=7fab045d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fab045d",
  null
  
)

export default component.exports